/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import {
  MARKET_LIST_STATUS,
  foreignOffersColumns,
} from 'pages/MarketListing/constant';
import {
  DELETE_OFFER,
  UPDATE_OFFER_STATUS,
} from 'pages/MarketListing/MarketListingGraphQL';
import StatusFormatter from 'components/StatusFormatter';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import Loader from 'components/common/Loader';
import { defaultDeleteFilter, showSequenceNumber } from 'utils/constants';
import {
  RECORD_DELETED_SUCCESSFULLY,
  STATUS_UPDATED_SUCCESSFULLY,
} from 'components/common/FSBToastify/types';
import { setBidDetails } from 'actions/bidDetailAction';
import { setVendorDetails } from 'actions/vendorDetailsAction';
import { cloneDeep, isEmpty } from 'lodash';
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import {
  EXPORTS_OFFERS,
  FOREIGN_OFFERS_QUERY,
  FOREIGN_OFFERS_SUBSCRIPTION_QUERY,
} from 'utils/CommonGraphQL';
import { role } from 'config/role';
import RBAC from 'hoc/RBAC';
import DownloadCSV from 'components/DownloadCSV';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import FilterResultBar from 'components/FilterResultBar';
import MarketListingMobileView from 'pages/MarketListing/components/MarketListingMobileView';

const ForeignOffersTable = ({
  searchString,
  filterValue,
  handleResetFilter,
  showAdvancedSearchBar,
  selectedProductName,
}) => {
  const dispatch = useDispatch();
  const [deleteRowId, setDeleteRowId] = useState('');
  // const [updateRecordModal, setUpdateRecordModal] = useState(false);
  // const [selectedUserRow, setSelectedUserRow] = useState([]);
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'entityName',
        joinAttributeName: 'trader',
        value: searchString,
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      {
        key: 'status',
        value: 'ACTIVE',
        type: 'STRING',
        op: 'EQ',
      },
      {
        key: 'totalQty',
        value: 0,
        type: 'INT',
        op: 'GT',
      },
      // {
      //   key: 'offerType',
      //   value: TYPE_OF_OFFER_AND_DEMAND.FOREIGN,
      //   type: 'STRING',
      //   op: 'EQ',
      // },
      { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });

  // Build the product name filter for GraphQL
  const productNameFilter = useMemo(() => {
    if (!selectedProductName) return [];
    return [
      {
        key: 'name',
        value: selectedProductName,
        joinAttributeName: 'grades.subCategory.product',
        type: 'STRING',
        op: 'EQ',
      },
    ];
  }, [selectedProductName]);

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    FOREIGN_OFFERS_QUERY,
    {
      variables: {
        ...filters,
        filter: [...filters.filter, ...filterValue, ...productNameFilter],
      },
      fetchPolicy: 'network-only',
    },
  );

  // console.log('foreign ', data);

  const [deleteOffer] = useMutation(DELETE_OFFER, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(RECORD_DELETED_SUCCESSFULLY);
      setDeleteRowId('');
      setDeleteRecord(!showDeleteRecord);
    },
    onError: () => { },
  });

  const [updateOfferStatus] = useMutation(UPDATE_OFFER_STATUS, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(STATUS_UPDATED_SUCCESSFULLY);
    },
    onError: () => { },
  });

  // const onClickEdit = ({ row }) => {
  //   setUpdateRecordModal(true);
  //   setSelectedUserRow(row?.original);
  // };

  // const onCloseUpdatePopup = () => {
  //   setUpdateRecordModal(false);
  // };

  const toggleDeleteRecord = (id) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId(id);
  };

  // const onDeleteConfirmation = async () => {
  //   const { id, email } = selectedUserRow;
  //   const rowId = selectedRows.map(({ original }) => original.id);
  //   const rowEmail = selectedRows.map(({ original }) => original.email);
  //   // await deleteUser({
  //   //   variables: {
  //   //     id: id ? [id] : rowId,
  //   //     email: email ? [email] : rowEmail,
  //   //   },
  //   // });

  //   setSelectedRows([]);
  //   setSelectedUserRow([]);
  //   setDeleteRecord(false);
  // };

  // const handlePageChange = (pageSize, pageNumber, sortColumnData) => {
  //   if (sortColumnData?.length && sortColumnData[0]?.id !== null) {
  //     setFilters({
  //       ...filters,
  //       filter: [],
  //       pageNo: pageNumber,
  //       pageSize,
  //       // search: { key: 'name', value: '' },
  //       sortCol: sortColumnData[0]?.id,
  //       sortDirection: sortColumnData[0]?.desc ? 'DESC' : 'ASC',
  //     });
  //   } else {
  //     setFilters({
  //       ...filters,
  //       filter: [],
  //       pageNo: pageNumber,
  //       pageSize,
  //       sortCol: null,
  //       sortDirection: null,
  //     });
  //   }
  // };

  const onDeleteConfirmation = async () => {
    try {
      await deleteOffer({
        variables: { id: deleteRowId },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  // const actionsFormatter = (cell) => {
  //   return (
  //     <ActionsFormatter
  //       isView={false}
  //       handleView={() => handleViewDetail(cell?.row?.original, 'offerType')}
  //       handleEdit={() => onClickEdit(cell)}
  //       handleDelete={() => toggleDeleteRecord(cell?.row?.original?.id)}
  //     />
  //   );
  // };

  const handleOfferStatus = async (e, cell) => {
    try {
      await updateOfferStatus({
        variables: { id: cell?.row?.original?.id, status: e.target.value },
      });
      //  refetch();
    } catch (err) {
      toast.error(err);
    }
  };

  const statusFormatter = (cell) => {
    return (
      <RBAC
        allowedRoles={[role.SUPER_ADMIN, role.ADMIN, role.SALES_HEAD]}
        disabled
      >
        {({ access }) => (
          <StatusFormatter
            options={MARKET_LIST_STATUS}
            defaultValue={cell?.row?.original?.status}
            handleChange={(e) => handleOfferStatus(e, cell)}
            inputDisabled={!access}
          />
        )}
      </RBAC>
    );
  };
  const handleLinkClick = (row) => {
    dispatch(
      setBidDetails({
        status: true,
        selectedBid: {
          ...row,
          bidType: 'offer',
          bidOfferType: 'FOREIGN',
          filters,
        },
      }),
    );
  };

  const linkFormatter = (cell) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer d-flex align-items-center"
        onClick={() => handleLinkClick(cell?.row?.original)}
        aria-hidden
      >
        <span className="me-2 f-16">{cell?.row?.original?.id}</span>{' '}
        <FaArrowUpRightFromSquare />
      </div>
    );
  };

  const handleNameClick = (row) => {
    if (!row?.trader?.id) return;
    dispatch(
      setVendorDetails({
        status: true,
        selectedVendor: row.trader,
      }),
    );
  };
  // const nameFormatter = (cell) => {
  //   return (
  //     <div
  //       className="text-blue-c5 fw-medium cursor-pointer"
  //       onClick={() => handleNameClick(cell?.row?.original?.trader)}
  //       aria-hidden
  //     >
  //       {cell?.row?.original?.trader?.firstName}{' '}
  //       {cell?.row?.original?.trader?.lastName}
  //     </div>
  //   );
  // };

  const findIndexOfItem = (item) => {
    return foreignOffersColumns.findIndex((itm) => itm.accessorKey === item);
  };

  // offersColumns[findIndexOfItem('actions')].cell = actionsFormatter;
  foreignOffersColumns[findIndexOfItem('status')].cell = statusFormatter;
  foreignOffersColumns[findIndexOfItem('id')].cell = linkFormatter;
  foreignOffersColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);
  // offersColumns[findIndexOfItem('trader')].cell = nameFormatter;

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.allForeignOffers?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
        id: filters.sortCol,
        desc: filters.sortDirection === 'DESC',
      },
  ];

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  const onGlobalSearch = (str) => {
    if (str) {
      setFilters((prevFilter) => {
        const updatedFilter = [...prevFilter.filter]; // Clone the filter array
        const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
        updatedFirstFilter.value = str;
        updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
        return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
      });
    }
  };

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: FOREIGN_OFFERS_SUBSCRIPTION_QUERY,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.allForeignOffers?.foreignOffers.findIndex(
          (val) =>
            val.id ===
            subscriptionData.data?.allForeignOffers?.foreignOffer?.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData.data?.allForeignOffers?.foreignOffer?.id)
          return prev;
        if (subscriptionData.data.allForeignOffers.action === 'CREATED') {
          const newOffer = subscriptionData.data.allForeignOffers.foreignOffer;
          const updatedOffers = [
            newOffer,
            ...newData.allForeignOffers.foreignOffers,
          ];

          const newTotalCount = prev.allForeignOffers.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.allForeignOffers = {
            ...newData.allForeignOffers,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            foreignOffers: updatedOffers,
          };
        }
        if (subscriptionData.data.allForeignOffers.action === 'UPDATED') {
          newData.allForeignOffers.foreignOffers[indexFound] =
            subscriptionData.data.allForeignOffers.foreignOffer;
        }

        if (subscriptionData.data.allForeignOffers.action === 'DELETED') {
          const { id } = subscriptionData.data.allForeignOffers.foreignOffer; // ID of the offer to remove
          const prevOffers = prev.allForeignOffers.foreignOffers;

          const updatedOffers = prevOffers.filter((val) => val.id !== id);

          const newTotalCount = prev.allForeignOffers.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedOffersData = {
            ...newData.allForeignOffers,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            foreignOffers: updatedOffers,
          };

          newData.allForeignOffers = updatedOffersData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.allForeignOffers?.foreignOffers)
    return <NoDataFound message="Offers not available" />;

  return (
    <>
      {showAdvancedSearchBar &&
        data?.allForeignOffers?.foreignOffers.length > 0 && (
          <FilterResultBar
            length={data?.allForeignOffers?.foreignOffers.length}
            type="foreign offers"
            handleResetFilter={handleResetFilter}
          />
        )}
      {/* <FSBModal
        title="Edit Offer"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={updateRecordModal}
        onClose={onCloseUpdatePopup}
        toggleAlert={onCloseUpdatePopup}
        modalClass="right-drawer"
      >
        {selectedUserRow?.offerType === types?.LIVE && (
          <EditLiveWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.OFFERTYPE}
          />
        )}
        {selectedUserRow?.offerType === types.FORWARD && (
          <EditForwardWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.OFFERTYPE}
          />
        )}
        {selectedUserRow?.offerType === types.FOREIGN && (
          <EditForeignWrapper
            onCloseUpdatePopup={onCloseUpdatePopup}
            currentRow={selectedUserRow}
            type={OFFER_AND_DEMAND_TYPE.OFFERTYPE}
          />
        )}
      </FSBModal> */}
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
      <DownloadCSV
        lazyQuery={EXPORTS_OFFERS}
        filters={{
          filter: [...filters.filter, ...filterValue, ...productNameFilter],
          sortCol: filters.sortCol,
          sortDirection: filters.sortDirection,
        }}
        apiKey="exportOffers"
        fileName="ForeignOffers"
        formats={["csv", "excel"]}
        classWrapper="market-listing-download"
        positionTop="-34px"
        positionRight="0"
      />
      <MarketListingMobileView
        rows={(data && data?.allForeignOffers?.foreignOffers) || []}
        filters={filters}
        kind="offer"
        totalPages={(data && data?.allForeignOffers?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        currentPageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        onIdClick={handleLinkClick}
        onNameClick={handleNameClick}
        renderStatusControl={(row, index) =>
          statusFormatter({ row: { original: row, index } })
        }
      >
        <FSBTable
          columns={foreignOffersColumns}
          data={(data && data?.allForeignOffers?.foreignOffers) || []}
          totalCount={(data && data?.allForeignOffers?.totalCount) || 0}
          totalPages={(data && data?.allForeignOffers?.totalPages) || 0}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          globalSearchStr={filters.filter[0].value}
          onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Vendors"
        />
      </MarketListingMobileView>
    </>
  );
};
export default ForeignOffersTable;
